const moment = require('moment')

const blockedBookings = [
  {
    office: 'Warsaw',
    roomName: 'reception',
    from: '2026-08-05',
    to: '2026-08-06'
  }
]

const isBookingBlocked = (office, roomName, date) => blockedBookings.some((blocked) => (
  blocked.office === office &&
  blocked.roomName === roomName &&
  moment(date).isBetween(blocked.from, blocked.to, 'day', '[]')
))

module.exports = { blockedBookings, isBookingBlocked }
